import React, { useRef, useEffect } from 'react'
import { Link } from 'gatsby'

const isPartiallyActive = ({isPartiallyCurrent}) => isPartiallyCurrent && { className: "list-menu-link active" }
const description = blocks => {
	const desc = blocks.filter(({blockName}) => blockName === "cgb/block-page-description")[0]
	return desc && desc.attrs.description
}


const Level1_2 = ({items, currentNodeId, currentPathName, currentLevel}) => {
	const navRef = useRef(null)

	// Boucle clavier : Tab en fin de liste → premier lien, Shift+Tab en début → dernier lien
	useEffect(() => {
		const nav = navRef.current
		if (!nav) return

		const getFocusables = () =>
			Array.from(nav.querySelectorAll('a[href]')).filter(
				el => el.offsetParent !== null
			)

		const handleKeydown = (e) => {
			const current = document.activeElement
			if (!nav.contains(current)) return

			// Espace et Entrée : activer le lien comme un clic (affiche le sous-menu / navigue)
			if (e.key === ' ' || e.key === 'Enter') {
				const link = current.closest('.list-menu-link') || (current.matches('a') ? current : null)
				if (link && nav.contains(link)) {
					e.preventDefault()
					try {
						sessionStorage.setItem('menu-focus-submenu', '1')
						const href = link.getAttribute('href') || link.getAttribute('to') || ''
						if (href) sessionStorage.setItem('menu-parent-link', href)
					} catch (err) {}
					link.click()
				}
				return
			}

			// Échap : revenir au lien du menu parent
			if (e.key === 'Escape') {
				try {
					const parentHref = sessionStorage.getItem('menu-parent-link')
					if (!parentHref) return
					e.preventDefault()
					const level = currentLevel === 2 ? 2 : 1
					const container = level === 1
						? document.querySelector('.menu-level-0')
						: document.querySelector('.submenu-container.level-1')
					if (!container) return
					let parentLink = container.querySelector(`a[href="${parentHref}"]`)
					if (!parentLink) parentLink = container.querySelector(`a[href="${parentHref.replace(/\/$/, '')}"]`)
					if (!parentLink) parentLink = container.querySelector(`a[href="${parentHref}/"]`)
					if (parentLink && typeof parentLink.focus === 'function') {
						parentLink.focus()
						sessionStorage.removeItem('menu-parent-link')
					}
				} catch (err) {}
				return
			}

			if (e.key !== 'Tab') return
			const focusables = getFocusables()
			if (focusables.length === 0) return
			const index = focusables.indexOf(current)
			if (index === -1) return

			if (e.shiftKey) {
				if (index === 0) {
					e.preventDefault()
					focusables[focusables.length - 1].focus()
				}
			} else {
				if (index === focusables.length - 1) {
					e.preventDefault()
					focusables[0].focus()
				}
			}
		}

		nav.addEventListener('keydown', handleKeydown)
		return () => nav.removeEventListener('keydown', handleKeydown)
	}, [items])

	// Validation des props
	if (!items || !Array.isArray(items) || items.length === 0) {
		return (
			<nav role="navigation" aria-label="Menu de navigation" className="menu-level12-empty">
				<p className="visually-hidden">Aucun élément de menu disponible</p>
			</nav>
		)
	}

	// hide_menu peut venir de GraphQL en boolean, number (0/1), string ("0"/"1"/"true") ou sous le nom hideMenu
	const isHiddenFromMenu = (val) =>
		val === true || val === 1 || val === '1' || (typeof val === 'string' && val.toLowerCase() === 'true')
	const getHideMenu = (node) => node?.hide_menu !== undefined ? node.hide_menu : node?.hideMenu

	const menuTitle = `Menu de navigation - Niveau ${currentLevel || '1-2'}`
	// Filtrer : n'afficher que les éléments non cachés du menu (hide_menu respecté strictement)
	const visibleItems = items.filter((item) => item != null).filter((item) => !isHiddenFromMenu(getHideMenu(item)))

	if (visibleItems.length === 0) {
		return (
			<nav role="navigation" aria-label={menuTitle} className="menu-level12-empty">
				<p className="visually-hidden">Aucun élément de menu visible</p>
			</nav>
		)
	}

	return (
		<nav ref={navRef} role="navigation" aria-label={menuTitle} className="menu-level12">
			<ul className="list-menu list-unstyled" role="menu">
				{visibleItems.map((item) => {
					const { full_slug, title, content_page, blocks, wordpress_parent } = item
					return (
						<li key={full_slug} className="list-menu-item" role="none">
							<Link 
								className={`list-menu-link ${(content_page ? 'content-page' : '')}`} 
								to={full_slug} 
								getProps={isPartiallyActive} 
								role="menuitem"
								aria-label={`${title}${description(blocks) ? ` - ${description(blocks)}` : ''}`}
								state={{
									prevPathName: currentPathName, 
									prevLevel: currentLevel, 
									menuNavigation: !content_page 
								}}
							>
								<strong
									dangerouslySetInnerHTML={{ __html: title }}
									aria-label={title}
								/>
								<br />
								<small className="description" aria-label={description(blocks)}>
									{description(blocks)}
								</small>
							</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

	

export default Level1_2
